import React from 'react';
import './PageStyles.css';

const ContactPage: React.FC = () => {
    return (
        <div className="page-container">
            <div className="container">
                <h1 className="page-title">Contact</h1>
                <div className="page-content contact-content">
                    <p>
                        We are always interested in hearing about new opportunities and collaborations.
                    </p>
                    <p>
                        <a href="mailto:hello@ekamlabs.com" className="contact-link" style={{ color: '#ffffff' }}>hello@ekamlabs.com</a>
                    </p>

                    <div className="social-links">
                        <a href="https://twitter.com/pjayswal" target="_blank" rel="noopener noreferrer">X (Twitter) ↗</a>
                        <a href="https://github.com/pjayswal" target="_blank" rel="noopener noreferrer">GitHub ↗</a>
                        <a href="https://linkedin.com/in/pjayswal" target="_blank" rel="noopener noreferrer">LinkedIn ↗</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPage;
